import Loadable from '../../components/loadable';

const ManageWebsiteDesign = Loadable({
  loader: () => import('../../pages/manage_website/website_design'),
});

angular.module('gym').value('ManageWebsiteDesign', ManageWebsiteDesign);
